import { Column, Row } from '@/components';
import { useService } from '@/containers/ActionServiceV2/context';
import { Switch } from '@headlessui/react';
import { FunctionComponent } from 'react';
import { toast } from 'react-toastify';
import { ControllerWithInput } from '../ControllerWithInput';
import { useAuth } from '@/contexts';
import { SupportedCountriesE } from '@/types/cyclone/models';
import { getCurrencySymbolFromCountry } from '@/utils/money';
import { Packs } from '@/containers/ActionServiceV2/components';

export const PricesTab: FunctionComponent = () => {
  const { session } = useAuth();
  const {
    editFormControl,
    isStripeConnected,
    addPack,
    deletePack,
    vendorPacks,
    isForSubscriptionEnabled,
    setIsForSubscriptionEnabled,
    toggleDownPaymentAvailable,
    aboutErrors,
    isForSubscription
  } = useService();

  //

  const country = session ? session.vendor!.country : SupportedCountriesE.ARGENTINA;
  const currency = getCurrencySymbolFromCountry(country);

  const handleIsForSubscriptionEnabled = (value: boolean) => {
    if (vendorPacks && vendorPacks.length > 0) {
      setIsForSubscriptionEnabled(false);
      toast.error('No se puede activar el plan mensual si ya hay packs creados');
    } else {
      setIsForSubscriptionEnabled(value);
    }
  };

  return (
    <div className="flex flex-col gap-6 pt-4 px-2 sm:px-0">
      <div className="w-full sm:border-2 mx-auto sm:max-w-[672px] min-h-[50vh] sm:border-gray-200 sm:rounded-xl sm:p-6 sm:bg-white">
        <Column className="w-full" gap={20}>
          <div>
            <span className="text-xl font-medium">Precio total del servicio</span>
            <p className="text-sm text-[#868686]">
              Indica el valor total que pagará tu cliente por el servicio.
            </p>
          </div>
          <Row gap={8} className={`${isStripeConnected ? 'w-full md:w-[80%]' : 'w-full'}`}>
            <div className={isStripeConnected ? 'w-full sm:w-1/2' : 'w-full sm:w-1/2'}>
              <ControllerWithInput
                name="price"
                placeholder={country}
                control={editFormControl}
                errors={aboutErrors.price}
                type="number"
                postfix={currency}
                floatLabel
                disabled={isForSubscriptionEnabled}
              />
            </div>
            {isStripeConnected && (
              <div className="w-1/2">
                <ControllerWithInput
                  name="price_usd"
                  placeholder="Otro país"
                  control={editFormControl}
                  errors={aboutErrors.price_usd}
                  type="number"
                  postfix="US$"
                  floatLabel
                  disabled={!editFormControl._getWatch('price')}
                />
              </div>
            )}
          </Row>
        </Column>
        {!toggleDownPaymentAvailable && (
          <Column className="w-full pt-8" gap={20}>
            <div>
              <span className="text-xl font-medium">Precios por pack</span>
              <p className="text-sm text-[#868686]">
                Crea packs y ofrece descuentos por cantidad a tus clientes.
              </p>
            </div>
            <Packs
              addPack={addPack}
              deletePack={deletePack}
              price={5}
              packs={vendorPacks}
              isForSubscriptionEnabled={isForSubscriptionEnabled}
              isStripeConnected={isStripeConnected}
            />
          </Column>
        )}

        {!session?.is_venue && isForSubscription && (
          <Column gap={20} className="pt-8 w-full">
            <span className="text-xl font-medium">Más opciones</span>
            <Row gap={20} className="flex-col md:flex-row w-full md:w-[80%]">
              <Column gap={5} className="w-full">
                <Row
                  align="center"
                  justify="center"
                  gap={16}
                  className="rounded h-12 bg-[#FFF] shadow-[0px_4px_23px_0px_#0000001C]"
                >
                  <p className="text-base">Usar sólo para plan mensual</p>
                  <Switch
                    checked={isForSubscriptionEnabled}
                    onChange={handleIsForSubscriptionEnabled}
                    className={`${
                      isForSubscriptionEnabled ? 'bg-[#7FB8FF]' : 'bg-[#CACACA]'
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                  >
                    <span
                      className={`${
                        isForSubscriptionEnabled ? 'translate-x-6 bg-[#0072FB]' : 'translate-x-1 bg-white'
                      } inline-block h-4 w-4 transform rounded-full transition`}
                    />
                  </Switch>
                </Row>
                <p className="text-sm text-[#868686]">
                  Puedes marcar tu servicio para que sólo se pueda contratar mediante planes mensuales. De
                  este modo, tus clientes no podrán hacer reservas individuales por encuentro.
                </p>
              </Column>
            </Row>
          </Column>
        )}
      </div>
    </div>
  );
};
